export enum TypeOf {
    UNDEFINED = 'undefined',
    OBJECT = 'object',
    BOOLEAN = 'boolean',
    NUMBER = 'number',
    BIG_INT = 'bigint',
    STRING = 'string',
    SYMBOL = 'symbol',
    FUNCTION = 'function'
}